import React from 'react';

import { LogoKP, ToasterItem, createClasses } from '@kp/react-ui';

const classes = createClasses({
  root: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  error: {
    marginTop: '20px',
    color: 'red',
    fontWeight: 700,
  },
  logo: {
    width: '300px',
    height: 'auto',
    '@media (prefers-reduced-motion: no-preference)': {
      animationName: 'pulse',
      animationDuration: '1.5s',
      animationTimingFunction: 'ease-in-out',
      animationIterationCount: 'infinite',
    },
  },
  '@global': {
    '@keyframes pulse': {
      '0%': { opacity: 1 },
      '50%': { opacity: 0.3 },
      '100%': { opacity: 1 },
    },
  },
});

export interface LoaderProps {
  /** Show an error instead, e.g. if loading has failed. */
  error?: Error | null;
}

export const Loader: React.FC<LoaderProps> = ({ error }) => (
  <div className={classes.root}>
    {error ? (
      <ToasterItem type="error">{error.message}</ToasterItem>
    ) : (
      <LogoKP className={classes.logo} />
    )}
  </div>
);
